import { render } from "./CouponForm.vue?vue&type=template&id=80b6b696&scoped=true"
import script from "./CouponForm.vue?vue&type=script&lang=js"
export * from "./CouponForm.vue?vue&type=script&lang=js"

import "./CouponForm.vue?vue&type=style&index=0&id=80b6b696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b6b696"]])

export default __exports__